var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "375px",
    height: "488px",
    viewBox: "0 0 375 488",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.2722229%",
    y1: "3.21222279%",
    x2: "57.8866967%",
    y2: "68.6958844%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4B20",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD643F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-version-Copy",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-108.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,445.62744 C26.1046644,471.590478 64.3176824,500.457292 108.521305,497.833459 C179.665775,493.610501 189.785213,412.356273 276.829662,386.89585 C361.250929,362.202576 417.278359,419.460913 461.71765,379.366211 C487.911053,355.732819 472.230448,332.425299 508.944215,292.523039 C538.223405,260.701579 562.535834,259.939662 579.784645,228.77169 C593.261324,204.418823 593.110904,18.3351444 590.837733,0 L0,0 L0,445.62744 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgMobile);
export default __webpack_public_path__ + "static/media/hero-bg-mobile.4cb84caa92d175254b930564a9aa6d9d.svg";
export { ForwardRef as ReactComponent };